/**
 * Пул иконок для кастомных категорий
 * 30 различных иконок MaterialCommunityIcons с пастельными цветами
 */

export interface CustomIconOption {
  icon: string;
  name: string; // Описательное имя для отладки
  color: string; // Пастельный цвет иконки
  backgroundColor: string; // Пастельный фон для иконки
}

export const CUSTOM_CATEGORY_ICONS: CustomIconOption[] = [
  // Еда и напитки
  { icon: 'shopping-bag', name: 'Яблоко', color: '#FF9F66', backgroundColor: '#FFF4ED' },
  { icon: 'coffee', name: 'Чашка', color: '#D4A574', backgroundColor: '#FDF8F3' },
  { icon: 'shopping-bag', name: 'Печенье', color: '#FFB3D1', backgroundColor: '#FFF0F8' },
  
  // Транспорт
  { icon: 'car', name: 'Велосипед', color: '#7B9CF5', backgroundColor: '#F0F4FF' },
  { icon: 'car', name: 'Поезд', color: '#8BB3F2', backgroundColor: '#F0F7FF' },
  { icon: 'car', name: 'Автобус', color: '#7BC8F6', backgroundColor: '#F0F9FF' },
  
  // Развлечения и хобби
  { icon: 'music', name: 'Музыка', color: '#C8A8E9', backgroundColor: '#F9F5FF' },
  { icon: 'play', name: 'Кино', color: '#AF52DE', backgroundColor: '#F5F0FF' },
  { icon: 'book', name: 'Книга', color: '#9AA7F5', backgroundColor: '#F0F2FF' },
  { icon: 'star', name: 'Палитра', color: '#FFB8D9', backgroundColor: '#FFF0F8' },
  { icon: 'camera', name: 'Камера', color: '#7BC8F6', backgroundColor: '#F0F9FF' },
  
  // Спорт и здоровье
  { icon: 'activity', name: 'Баскетбол', color: '#6BCB9A', backgroundColor: '#F0FDF4' },
  { icon: 'activity', name: 'Йога', color: '#9AA7F5', backgroundColor: '#F0F2FF' },
  { icon: 'activity', name: 'Таблетка', color: '#FF9AA2', backgroundColor: '#FFF0F1' },
  
  // Дом и быт
  { icon: 'home', name: 'Диван', color: '#D4A574', backgroundColor: '#FDF8F3' },
  { icon: 'lightbulb', name: 'Лампа', color: '#FFD93D', backgroundColor: '#FFFEF0' },
  { icon: 'settings', name: 'Стиральная машина', color: '#7BC8F6', backgroundColor: '#F0F9FF' },
  { icon: 'settings', name: 'Инструменты', color: '#9CA3AF', backgroundColor: '#F3F4F6' },
  
  // Технологии
  { icon: 'laptop', name: 'Ноутбук', color: '#8BB3F2', backgroundColor: '#F0F7FF' },
  { icon: 'tablet', name: 'Планшет', color: '#7BC8F6', backgroundColor: '#F0F9FF' },
  { icon: 'gamepad', name: 'Геймпад', color: '#C8A8E9', backgroundColor: '#F9F5FF' },
  
  // Покупки и финансы
  { icon: 'shopping-cart', name: 'Покупки', color: '#FF9F66', backgroundColor: '#FFF4ED' },
  { icon: 'credit-card', name: 'Кредитная карта', color: '#6BCB9A', backgroundColor: '#F0FDF4' },
  { icon: 'building', name: 'Банк', color: '#7B9CF5', backgroundColor: '#F0F4FF' },
  
  // Природа и животные
  { icon: 'star', name: 'Цветок', color: '#FFB3D1', backgroundColor: '#FFF0F8' },
  { icon: 'star', name: 'Дерево', color: '#6BCB9A', backgroundColor: '#F0FDF4' },
  { icon: 'star', name: 'Рыба', color: '#7BC8F6', backgroundColor: '#F0F9FF' },
  
  // Разное
  { icon: 'star', name: 'Звезда', color: '#FFD93D', backgroundColor: '#FFFEF0' },
  { icon: 'heart', name: 'Сердце', color: '#FF9AA2', backgroundColor: '#FFF0F1' },
  { icon: 'gift', name: 'Подарок', color: '#FFB8D9', backgroundColor: '#FFF0F8' },
];

/**
 * Получает иконку по индексу
 */
export function getCustomIconByIndex(index: number): CustomIconOption {
  return CUSTOM_CATEGORY_ICONS[index % CUSTOM_CATEGORY_ICONS.length];
}

/**
 * Получает иконку по имени
 */
export function getCustomIconByName(iconName: string): CustomIconOption | undefined {
  return CUSTOM_CATEGORY_ICONS.find(icon => icon.icon === iconName);
}

